module.exports = __webpack_public_path__ + "img/3bcee00.jpg";